import { render, staticRenderFns } from "./equipManage.vue?vue&type=template&id=3207747a&scoped=true"
import script from "./equipManage.vue?vue&type=script&lang=js"
export * from "./equipManage.vue?vue&type=script&lang=js"
import style0 from "./equipManage.vue?vue&type=style&index=0&id=3207747a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3207747a",
  null
  
)

export default component.exports